import { useI18n } from "../lib/i18n";

export type RfqRequestType = "services" | "items";
export type RfqTypeDetail = { requestType?: RfqRequestType };

/** Cards, details and profile summaries share recorded-type labels, including legacy fallback ([rfq.request-type](../../../docs/product/rfqs.md#rfq-request-type)). */
export function rfqTypeLabelKey(requestType: unknown): string {
  return requestType === "services" ? "rfq.type.services"
    : requestType === "items" ? "rfq.type.items" : "rfq.type.unspecified";
}

export function RfqTypeBadge({ requestType }: { requestType?: unknown }) {
  const { t } = useI18n();
  const labelKey = rfqTypeLabelKey(requestType);
  return <span className="chip bg-navy-50 text-navy" data-testid="rfq-type">{t(labelKey)}</span>;
}
